import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import UpgradeItemBlockData from 'app/Models/Content/UpgradeItemBlockData';
import UpgradeItemsBlockData from 'app/Models/Content/UpgradeItemsBlockData';
import {Container} from 'reactstrap';
import UpgradeItemBlock from '../UpgradeItemBlock';
import classNames from 'classnames';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';

const LARGE_BLOCKS = 1;

const UpgradeItemsBlock = (props: ComponentProps<UpgradeItemsBlockData>) => {
  const {data, context} = props;

  return (
    <BlockWrapper props={props}>
      <div className={classNames('UpgradeItemsBlock', data.upgradeItemBlockAppearance.value === LARGE_BLOCKS && `appearance_large`)}>
        {/* mobile */}
        <Swiper pagination slidesPerView={1.3} spaceBetween={20} centeredSlides className='UpgradeItemsBlock__swiper d-block d-md-none'>
          {data.upgradeItems.expandedValue?.map((item: UpgradeItemBlockData, i) => (
            <SwiperSlide key={i}>
              <UpgradeItemBlock data={item} context={context} />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* 768 to 992px */}
        <Swiper slidesPerGroup={2} slidesPerView={2} className='UpgradeItemsBlock__swiper	d-none d-md-block d-lg-none'>
          {data.upgradeItems.expandedValue?.map((item: UpgradeItemBlockData, i) => (
            <SwiperSlide key={i}>
              <UpgradeItemBlock data={item} context={context} />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* desktop */}
        <Container className='UpgradeItemsBlock__items-desktop d-none d-lg-block'>
          <div className='UpgradeItemsBlock__items-desktop__wraper'>
            <ContentArea noWrap context={context} data={data.upgradeItems} />
          </div>
        </Container>
      </div>
    </BlockWrapper>
  );
};

export default UpgradeItemsBlock;
